export const formatUserName = (user: any, userId: number) => {
  if (!user) return `User ${userId}`;

  if (user.name) {
    const nameParts = user.name.split(' ');
    if (nameParts.length >= 2) {
      const firstName = nameParts[0];
      const lastName = nameParts[nameParts.length - 1];
      return `${firstName} ${lastName.charAt(0)}.`;
    }
    return user.name;
  }
  return user.email;
};
